<script lang="ts">
	 /**
	 * Container for video action buttons.
	 * Use with VideoActionButton components in the default slot.
	 *
	 * @example
	 * <VideoActions>
	 *   <VideoActionButton icon="fas fa-camera" label="Photo" on:click={handlePhoto} />
	 *   <VideoActionButton icon="fas fa-circle-dot" label="Record" on:click={handleRecord} />
	 * </VideoActions>
	 */
</script>

<div class="video-actions">
	<slot />
</div>

<style>
	.video-actions {
		display: flex;
		gap: var(--spacing-s, 8px);
		padding: var(--spacing-s, 8px);
		background-color: var(--color-0);
		width: 100%;
	}
</style>
